import EscalationSupportTableContainer from './EscalationSupportTableContainer';

export default EscalationSupportTableContainer;
